mutation ResendOrganizationUserInvitation($id: ID!) {
  resendOrganizationUserInvitation(id: $id) {
    id
    welcomeEmailSentAt
  }
}
